import React from 'react';

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
  className?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Processing your request...',
  fullScreen = true,
  className = '',
}) => {
  return (
    <div 
      className={`
        flex flex-col items-center justify-center
        ${fullScreen ? 'fixed inset-0 z-50 bg-gradient-to-br from-[#2c3e50]/95 to-[#3498db]/95 backdrop-blur-sm' : 'p-4 md:p-8'}
        ${className}
      `}
    >
      <div className="relative">
        <div className="h-12 w-12 md:h-16 md:w-16">
          {/* Outer ring */}
          <div className="absolute h-12 w-12 md:h-16 md:w-16 rounded-full border-2 border-[#1abc9c]/30"></div>
          {/* Middle ring */}
          <div className="absolute h-9 w-9 md:h-12 md:w-12 top-1.5 left-1.5 md:top-2 md:left-2 rounded-full border-2 border-[#f1c40f]/30"></div>
          {/* Progress indicator */}
          <div className="absolute h-12 w-12 md:h-16 md:w-16 rounded-full border-2 border-t-[#1abc9c] border-r-[#f1c40f] border-b-[#3498db] border-l-transparent animate-[spin_1.5s_linear_infinite]"></div>
        </div>
      </div>
      
      {message && (
        <div className="mt-4 md:mt-6 text-center px-4">
          <p className="text-base md:text-lg font-medium text-white">{message}</p>
        </div>
      )}
    </div>
  );
};

export default LoadingScreen;